import React from "react";
import BasketTicket from "../TicketPage/BasketTicket";
import FormDialog from "../../shared/FormDialog";
import { clearBasket } from "../../store/basket/basketActions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { FINALIZE_PAGE } from "../../Routing/routes";
import { State } from "../../store";
import { setErrors } from "../../store/alerts/alertsActions";
import { TicketBillLine } from "../../models/TicketBillLine";
import { TicketAccess } from "../../models/TicketAccess";
import { get } from "../../api";
import { UNBLOCK_SEAT } from "../../api/apiRoutes";
import { Identifiable } from "../../models/Identifiable";
import { ApiResult } from "../../models/ApiResult";
import tryCatchRequest from "../../utils/tryCatchRequest";
import getId from "../../utils/getId";

interface IProps {
  show: boolean;
  onClose: () => void;
}
const Basket: React.FC<IProps> = ({ show, onClose }: IProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const basket = useSelector((state: State) => state.basket.basket);
  const handleAdditionalButton = () => {
    if (basket.length === 0) {
      dispatch(setErrors(["Twój koszyk jest pusty, aby przejść do podsumowania dodaj interesujące Cię bilety"]));
    } else {
      history.push(FINALIZE_PAGE);
      onClose();
    }
  };

  const handleClearBasket = async () => {
    const ticketAccessList = basket.reduce(
      (acc: TicketAccess[], item: TicketBillLine) => acc.concat(item.ticketAccessList),
      []
    );
    const seatsList = ticketAccessList.some(item => Boolean(getId(item.seat)));
    if (seatsList) {
      await tryCatchRequest(
        async () => await unblockSeat(ticketAccessList),
        () => {
          dispatch(clearBasket());
        },
        dispatch
      );
    } else {
      dispatch(clearBasket());
    }
  };

  const unblockSeat = async (ticketAccessList: TicketAccess[]) => {
    const response = await Promise.all(
      ticketAccessList.map(async item => await get(UNBLOCK_SEAT(item.exercise, item.seat ?? ({} as Identifiable))))
    );
    return response.reduce(
      (acc: ApiResult, item: ApiResult) => ({
        isError: item.isError ? item.isError : acc.isError,
        errorTable: item.errorTable.length > 0 ? item.errorTable : acc.errorTable
      }),
      {} as ApiResult
    );
  };

  return (
    <FormDialog
      wide={true}
      open={show}
      title={`Twój koszyk`}
      onClose={onClose}
      showTitle={true}
      acceptText={"Wyczyść koszyk"}
      cancelText={"Zamknij"}
      onAccept={() => handleClearBasket()}
      showAdditionalButton
      additionalButtonText={"Podsumowanie"}
      onAdditionalAction={handleAdditionalButton}
    >
      <div style={{ padding: "2%" }}>
        <BasketTicket />
      </div>
    </FormDialog>
  );
};

export default Basket;
